import styles from './AppsLinks.module.sass';

/**
 * Apps links (Google Play, App Store, etc.)
 * LinkComponent is used for rendering the link. If it's not provided fallback to HTMLAnchorElement
 */
export const AppsLinks = ({ links, LinkComponent }: { links: any; LinkComponent?: any }) => (
    <div className={styles.appsLinks}>
        {links.map((link: { link: any; target: any; image: string | undefined; alt: any }, index: string) => {
            const props = {
                href: link.link,
                target: link.target,
                children: <img src={link.image} alt={link.alt || 'App link'} />,
                'data-test-id': `footer-app-link-${link.alt?.toLowerCase().replace(/\s+/g, '-') || index}`,
            };

            return LinkComponent ? (
                <LinkComponent {...props} key={index + '_apps'} />
            ) : (
                <a {...props} key={index + '_apps'} aria-label={link.alt || 'App link'}></a>
            );
        })}
    </div>
);
